<template>
  <parent>
    <div class="position-relative h-100 mh-100 overflow-hidden">
      <job-template-details
        v-if="!fetchingEmptyJobTemplate && !fetchingOutputGroupOptions && !fetchingJobTemplate"
        edit
      />
      <loading-page v-else />
    </div>
  </parent>
</template>

<script>
import JobTemplateDetails from './view/JobTemplateDetails.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'ViewJobTemplate',
  components: { JobTemplateDetails },
  data() {
    return {
    }
  },
  computed: {
    fetchingEmptyJobTemplate() {
      return this.$store.state.jobTemplates.fetchingEmptyJobTemplate
    },
    fetchingJobTemplate() {
      return this.$store.state.jobTemplates.fetchingJobTemplate
    },
    fetchingOutputGroupOptions() {
      return this.$store.state.jobTemplates.fetchingOutputGroupOptions
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.fetchEmptyJobTemplate()
      this.fetchJobTemplate()
      this.fetchOutputGroupOptions()
    },
    fetchEmptyJobTemplate() {
      this.$store.dispatch('jobTemplates/fetchEmptyJobTemplate')
    },
    fetchJobTemplate() {
      this.$store.dispatch('jobTemplates/fetchJobTemplateById', this.$route.params.id).catch(err => redirectError(err, this.$router, this.$route.path))
    },
    fetchOutputGroupOptions() {
      this.$store.dispatch('jobTemplates/fetchOutputGroupOptions')
    },
  },

}
</script>

<style>

</style>
